import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import "./heroVideo.css";
import CustomButton from "../Button/CustomButton";
import { useNavigate } from "react-router-dom";
import heroBgVideoWebm from "../../assets/HeronewBgvideo.webm";
import heroBgVideoMp4 from "../../assets/HeronewBgvideo.mp4";

const slides = [
  {
    id: "01",
    tag: "Integrated Renewable Energy Advisory",
    bigTitle: "Integrated Renewable Energy Advisory",
    smallTitle: "Finance • Engineering • Execution",
    description: "Supporting renewable energy projects from planning to delivery.",
  },
  {
    id: "02",
    tag: "Renewable Energy Advisory Partner",
    bigTitle: "Delivering bankable clean energy solutions",
    smallTitle: "Project Planning & Delivery",
    description: "Helping developers and investors bring projects to life.",
  },
  {
    id: "03",
    tag: "End-to-End Renewable Support",
    bigTitle: "From project ideas to execution",
    smallTitle: "Technical & Financial Expertise",
    description: "Supporting solar, BESS, hybrid, and emerging energy projects.",
  },
];

const HeroVideo = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4500);

    return () => clearInterval(timer);
  }, [currentSlide]);

  const slideVariants = {
    initial: { opacity: 0, y: 15 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
    exit: { opacity: 0, y: -15, transition: { duration: 0.3, ease: "easeIn" } },
  };

  const slide = slides[currentSlide];

  return (
    <section className="hero-full-container" id="home">
      <div className="hero-inner-frame">
        {/* Single Persistent Background Video */}
        <div className="video-background-wrapper">
          <video 
            autoPlay 
            muted 
            loop 
            playsInline 
            preload="metadata"
            className="hero-video-bg"
          >
            <source src={heroBgVideoWebm} type="video/webm" />
            <source src={heroBgVideoMp4} type="video/mp4" />
          </video>
        </div>

        {/* Sliding Text Content with AnimatePresence (mode="wait" completely prevents overlapping/overwriting) */}
        <div className="hero-content-viewport">
          <Container className="hero-content-container">
            <div className="hero-content-wrapper d-flex align-items-lg-end">
              <AnimatePresence mode="wait">
                <motion.div
                  key={currentSlide}
                  className="hero-motion-slide w-100"
                  variants={slideVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                >
                  <Row className="w-100 align-items-end gy-4 m-0">
                    {/* Left Column: Big Title */}
                    <Col lg={7} md={12} className="text-start p-0">
                      <div className="hero-tag-pill mb-3">
                        {slide.tag}
                      </div>
                      <h1 className="hero-display-title">
                        {slide.bigTitle}
                      </h1>
                    </Col>

                    {/* Right Column: Content & Buttons */}
                    <Col lg={5} md={12} className="ps-lg-5 d-flex flex-column align-items-start p-0">
                      <div className="slide-info-wrapper text-start">
                        <span className="slide-number">{slide.id}</span>
                        <h2 className="slide-small-title">{slide.smallTitle}</h2>
                        <p className="slide-description">
                          {slide.description}
                        </p>
                        
                        <div className="hero-btn-group d-flex gap-3">
                          <CustomButton
                            variant="white"
                            size="md"
                            text="Discuss Your Project"
                            showArrow={false}
                            onClick={() => navigate("/contact")}
                          />
                          <button 
                            className="btn-outline-glass"
                            onClick={() => {
                              const el = document.getElementById("services");
                              if (el) {
                                el.scrollIntoView({ behavior: "smooth" });
                              } else {
                                navigate("/services/finance");
                              }
                            }}
                          >
                            Explore Services
                          </button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </motion.div>
              </AnimatePresence>
            </div>
          </Container>
        </div>

      </div>
    </section>
  );
};

export default HeroVideo;
